/*
  Direct to checkout
  ------------------
  After any successful "add to cart", send the customer straight to the
  checkout page instead of showing the cart notification / cart page.

  Covers every add-to-cart path on the store:
    1. fetch() based adds  - product-form.js, quick view, most apps
    2. XMLHttpRequest adds - jQuery ($.post '/cart/add.js'), older apps
    3. plain form posts    - forms that post to /cart/add without JS

  To disable, remove the <script> tag for this file from layout/theme.liquid.
*/
(function () {
  var ADD_TO_CART = /\/cart\/add(\.js)?(\?|$)/;
  var redirecting = false;

  function checkoutUrl() {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return root.replace(/\/$/, '') + '/checkout';
  }

  function goToCheckout() {
    if (redirecting) return;
    redirecting = true;
    window.location.href = checkoutUrl();
  }

  function isAddToCart(url) {
    try {
      return ADD_TO_CART.test(String(url));
    } catch (e) {
      return false;
    }
  }

  // 1. fetch() based add to cart
  var nativeFetch = window.fetch;
  if (typeof nativeFetch === 'function') {
    window.fetch = function (input, init) {
      var url = input && input.url ? input.url : input;
      var promise = nativeFetch.apply(this, arguments);
      if (isAddToCart(url)) {
        promise
          .then(function (response) {
            if (response && response.ok) goToCheckout();
          })
          .catch(function () {});
      }
      return promise;
    };
  }

  // 2. XMLHttpRequest based add to cart
  var nativeOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    if (isAddToCart(url)) {
      this.addEventListener('load', function () {
        if (this.status >= 200 && this.status < 300) goToCheckout();
      });
    }
    return nativeOpen.apply(this, arguments);
  };

  // 3. Plain (non-AJAX) form posts to /cart/add - tell Shopify where to land.
  //    Runs after the form's own submit handler, so AJAX forms are skipped.
  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form || event.defaultPrevented) return;
    if (!isAddToCart(form.getAttribute('action') || '')) return;
    if (form.querySelector('[name="return_to"]')) return;

    var input = document.createElement('input');
    input.type = 'hidden';
    input.name = 'return_to';
    input.value = checkoutUrl();
    form.appendChild(input);
  });
})();
